/* Saatchi Watch — About page. Timeline progress line only; everything else reuses sw.js. */
(() => {
'use strict';
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
function timeline(el) {
  if (el._sw) return; el._sw = 1;
  const line = el.querySelector('[data-line]'), steps = [...el.querySelectorAll('.ab-step')];
  if (!steps.length) return;
  if (RM) { steps.forEach(s => s.classList.add('in')); if (line) line.style.setProperty('--p', 1); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -35% 0px' });
  steps.forEach(s => io.observe(s));
  if (!line) return;
  let tick = false;
  const run = () => {
    const r = el.getBoundingClientRect(), mid = innerHeight * 0.62;
    const p = Math.max(0, Math.min(1, (mid - r.top) / Math.max(1, r.height)));
    line.style.setProperty('--p', p.toFixed(3));
    tick = false;
  };
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener('resize', run, { passive: true });
  run();
}
function init(r = document) { r.querySelectorAll('[data-timeline]').forEach(timeline); }
document.addEventListener('shopify:section:load', e => init(e.target));
document.readyState === 'loading' ? addEventListener('DOMContentLoaded', () => init()) : init();
})();